module.exports = {"370271400":"北部园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370271.json
// module id = 1488
// module chunks = 0